Apt.fn.extend('property', {
	/**
	 * Transform thumbnail images
	 *
	 * @param {Array} images
	 * @param {String} prefix
	 * @returns {Array}
	 */
	transformThumbs(images, prefix) {
		images = images.map((image, i) => {
			image.path = prefix + '/large/' + image.key + '.jpg';
			image.small = image.path.replace('/large/', '/small/');

			image.position = i + 1;

			if ((! i && images.length > 6) || i > 6) {
				image.lazy = true;
			}

			return image;
		});

		images.push(images.shift());

		return images;
	}
}, {
	/**
	 * Initialize a media gallery
	 */
	initImages() {
		const scope = this;
		const images = $.context('media.images', []);

		if (! window.crawler && images.length > 1) {
			$.app.media.$set('images.1.fetched', true);
		}

		scope.images = Apt.fn.gallery()
			.init({
				app: $.app.media,
				id: $.context('id'),
				bind: true,
				delegate: '$images',
				large: true,
				preload: Apt.panel.opened(),
				data: {
					hash: scope.context.hash,
					images: images
				}
			});
	},

	/**
	 * Initialize thumbnails
	 */
	initThumbnails() {
		const $thumbs = $$('propertyThumbs');

		if (! $thumbs.length) {
			return;
		}

		const scope = this;
		const activeClass = '-is-active';

		let $parent = $thumbs.parent();

		scope.lazyThumbs = Apt.fn.lazy()
			.init($('img[data-src]', $thumbs), {
				context: $parent,
				margin: 200
			});

		$.events.on('$thumbnail', 'click', (e, el) => {
			scope.openTab('images');

			$(el).addClass(activeClass)
				.siblings()
				.removeClass(activeClass);

			scope.images.move(
				Number(el.dataset.position)
			);
		}, {
			cancel: true,
			namespace: 'property',
			delegate: $thumbs
		});

		LS.util.idle(() => {
			const $button = $$('propertyScroll');

			$button.on('mousedown', () => {
				$parent.scrollTop(320, true);
			}, {
				namespace: 'property',
				once: true
			});

			$parent.on('scroll', () => {
				$button.hide();
			}, {
				namespace: 'property',
				once: true
			});
		});
	}
});